import { ticketManagersEnum } from "../Ticketing/TicketingUtils.js";
import { useMemo } from "react";

export const useSystemDefaults = () => {
  const systemDefaults = useMemo(() => {
    return {
      ticketing: [
        {
          type: ticketManagersEnum.JIRA,
          iconName: "JIRA",
          name: "Jira",
          unavailable: true,
          instances: [],
        },
        {
          type: ticketManagersEnum.JIRA_ON_PREM,
          iconName: "JIRA_ON_PREM",
          name: "Jira On Prem",
          unavailable: true,
          instances: [],
        },
        {
          type: ticketManagersEnum.MONDAY,
          iconName: "MONDAY",
          name: "monday.com",
          unavailable: true,
          instances: [],
        },
        {
          type: ticketManagersEnum.SERVICENOW,
          iconName: "SERVICENOW",
          name: "ServiceNow",
          unavailable: true,
          instances: [],
        },
        {
          type: ticketManagersEnum.FIBERY,
          iconName: "FIBERY",
          name: "Fibery",
          unavailable: true,
          instances: [],
        },
        {
          type: ticketManagersEnum.ZENDESK,
          iconName: "ZENDESK",
          name: "ZenDesk",
          unavailable: true,
          instances: [],
        },
        {
          type: ticketManagersEnum.AZURE_DEVOPS,
          iconName: "AZURE_DEVOPS",
          name: "Azure Devops",
          unavailable: true,
          instances: [],
        },
        {
          type: ticketManagersEnum.BMC_HELIX,
          iconName: "BMC_HELIX",
          name: "BMC Helix",
          unavailable: true,
          instances: [],
        },
        {
          type: ticketManagersEnum.GITHUB_ISSUES,
          iconName: "GITHUB_ISSUES",
          name: "Github Issues",
          unavailable: true,
          instances: [],
        },
        {
          type: ticketManagersEnum.FRESHSERVICE,
          iconName: "FRESHSERVICE",
          name: "Freshservice",
          unavailable: true,
          instances: [],
        },
        {
          type: ticketManagersEnum.SERVICE_DESK_ON_PREM,
          iconName: "SERVICE_DESK_ON_PREM",
          name: "Service Desk On Prem",
          unavailable: true,
          instances: [],
        },
        {
          type: ticketManagersEnum.TEAMDYNAMIX,
          iconName: "TEAMDYNAMIX",
          name: "TeamDynamix",
          unavailable: true,
          instances: [],
        },
      ],
      notifications: [
        {
          type: ticketManagersEnum.SLACK,
          iconName: "SLACK",
          name: "Slack",
          unavailable: true,
          instances: [],
        },
        {
          type: ticketManagersEnum.MICROSOFT_TEAMS,
          iconName: "MS_TEAMS",
          name: "Microsoft Teams",
          unavailable: true,
          instances: [],
        },
      ],
    };
  }, []);

  return {
    systemDefaults,
  };
};
